import React from 'react'
import { Space, Button, Typography, theme } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

const { Text } = Typography

interface BulkActionToolbarProps {
    selectedCount: number
    onClearSelection: () => void
    actions: React.ReactNode
}

export const BulkActionToolbar: React.FC<BulkActionToolbarProps> = ({
    selectedCount,
    onClearSelection,
    actions
}) => {
    const { token } = theme.useToken()

    if (selectedCount === 0) return null

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 24,
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: token.colorBgElevated,
                padding: '12px 24px',
                borderRadius: token.borderRadiusLG,
                boxShadow: token.boxShadowSecondary,
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                gap: 24,
                border: `1px solid ${token.colorBorder}`
            }}
        >
            <Space>
                <Button
                    type="text"
                    icon={<CloseOutlined />}
                    onClick={onClearSelection}
                />
                <Text strong>{selectedCount} selected</Text>
            </Space>
            <Space>
                {actions}
            </Space>
        </div>
    )
}
